export default {

    props: {
        dataInteraction: {
            type: Object,
        },
    },

    computed: {
        interaction() {
            return this.dataInteraction
        },

        interactionStored() {
            return this.$store.state.interactions.list.find(interaction => interaction.id === this.interaction.id)
        },

        optionsCount() {
            return this.interactionStored.opcoes.length
        },
    }

}
